<template>
  <v-container
    id="ogn-log"
    fluid
    tag="section"
  >
    <material-card
      icon="$ogn"
      icon-small
      color="accent"
      :title="page_title"
    >
      <v-card-title>
        <v-spacer v-if="!$vuetify.breakpoint.mdAndDown" />
        <date-field
          v-model="flight_date"
          field-name="date"
          :events="flight_dates"
          hide-details
          class-self="mr-1"
        />
        <v-text-field
          v-model="search"
          append-icon="$search"
          class="ml-auto"
          hide-details
          :label="$t('search_records')"
          single-line
          style="max-width: 250px;"
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :search="search"
          :footer-props="footerProps"
        >
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :color="action.color"
              :disabled="action.disable"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item.id)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import { format } from 'date-fns'

  export default {
    name: 'Transactions',
    components: {
    },
    data () {
      return {
        items: [],
        // table
        flight_dates: [],
        flight_date: '',
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('user/options'),
      search: sync('user/search'),
      headers () {
        return [
          {
            text: this.$t('fields.action'),
            align: 'start',
            sortable: false,
            value: 'action',
          },
          {
            text: this.$t('fields.reg_num'),
            sortable: false,
            value: 'reg_num',
          },
          {
            text: this.$t('fields.ogn_id'),
            sortable: false,
            value: 'ogn_id',
          },
          {
            text: this.$t('fields.time'),
            sortable: false,
            value: 'time',
          },
          {
            text: this.$t('fields.status'),
            sortable: false,
            value: 'status',
          },
        ]
      },
      actions () {
        return [
          // { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.edit, disable: !this.editor },
        ]
      },
      page_title () { return this.$t('ogn_log') },
      // editor () { return this.profile.can['membership-edit'] },
    },
    watch: {
      flight_date: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.fetchDatasource({ sourceType: 'flight-dates' }).then(response => {
        this.flight_dates = response.map(m => m.date) //  { date: '2021-15-15', events: ['2021-15-15'] }
        const today = format(new Date(), 'yyyy-MM-dd')
        this.flight_date = this.last_date ?? (response.length !== 0 ? response[0].date : today)
        this.load()
      })
    },
    methods: {
      getList: call('debug/ognLog'),
      fetchDatasource: call('datasource/fetchDatasource'),
      async load () {
        try {
          await this.getList({
            date: this.flight_date,
          }).then(response => {
            this.items = response
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      edit (id) {
        this.$router.push(`/membership/${id}`).catch(() => {})
      },
    },
  }
</script>
